var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 144,
    viewBox: "0 0 143 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.5,
    cy: 68,
    rx: 67.5,
    ry: 68,
    fill: "#171616",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.642 47.0909H43.0909L51.9545 68.7045H52.3636L61.2273 47.0909H71.6761V82H63.4602V60.5568H63.1705L54.7841 81.7784H49.5341L41.1477 60.4375H40.858V82H32.642V47.0909ZM109.888 64.5455C109.888 68.3864 109.149 71.642 107.672 74.3125C106.195 76.983 104.195 79.0114 101.672 80.3977C99.1605 81.7841 96.3423 82.4773 93.2173 82.4773C90.081 82.4773 87.2571 81.7784 84.7457 80.3807C82.2344 78.983 80.2401 76.9545 78.7628 74.2955C77.2969 71.625 76.5639 68.375 76.5639 64.5455C76.5639 60.7045 77.2969 57.4489 78.7628 54.7784C80.2401 52.108 82.2344 50.0795 84.7457 48.6932C87.2571 47.3068 90.081 46.6136 93.2173 46.6136C96.3423 46.6136 99.1605 47.3068 101.672 48.6932C104.195 50.0795 106.195 52.108 107.672 54.7784C109.149 57.4489 109.888 60.7045 109.888 64.5455ZM101.263 64.5455C101.263 62.2727 100.939 60.3523 100.291 58.7841C99.6548 57.2159 98.7344 56.0284 97.5298 55.2216C96.3366 54.4148 94.8991 54.0114 93.2173 54.0114C91.5469 54.0114 90.1094 54.4148 88.9048 55.2216C87.7003 56.0284 86.7741 57.2159 86.1264 58.7841C85.4901 60.3523 85.1719 62.2727 85.1719 64.5455C85.1719 66.8182 85.4901 68.7386 86.1264 70.3068C86.7741 71.875 87.7003 73.0625 88.9048 73.8693C90.1094 74.6761 91.5469 75.0795 93.2173 75.0795C94.8991 75.0795 96.3366 74.6761 97.5298 73.8693C98.7344 73.0625 99.6548 71.875 100.291 70.3068C100.939 68.7386 101.263 66.8182 101.263 64.5455Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_5",
    x: 0,
    y: 0,
    width: 143,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_5",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/mo.c2db42f709e87930dc9a01f8c02fb11e.svg";
export { ForwardRef as ReactComponent };